export default {
  add_rate: 'Lisää hinta',
  remove_rate: 'Poista hinta',
  gateways: {
    adyen: 'Adyen',
  },
  methods: {
    fallback: 'Mikä tahansa maksutapa',
    card: 'Kortti',
    apple_pay: 'Apple Pay',
    google_pay: 'Google Pay',
    link: 'Link',
    paypal: 'PayPal',
    pay_by_bank: 'Pay by Bank',
    sepa_debit: 'SEPA-suoraveloitus',
    sofort: 'Sofort',
    giropay: 'giropay',
    bacs_debit: 'Bacs-suoraveloitus',
    stripe_other: 'Muut Stripe-menetelmät',
  },
  fields: {
    percentage: 'Prosentti',
    fixed: 'Kiinteä summa',
    min: 'Vähimmäissumma',
  },
  // Spelled out from the row's own values, so a rate reads as the fee it
  // produces. {{method}} is the payment method, {{fixed}}/{{floor}} are
  // formatted amounts, {{percentage}} is a plain number.
  explanation: {
    none: 'Maksutavalle {{method}} ei ole vielä asetettu maksua — näistä maksuista saadaan 0 % kate, kunnes hinta asetetaan.',
    floor_only:
      'Maksutavalla {{method}} käsittelymaksu on {{floor}} jokaisesta maksusta, riippumatta tilauksen summasta.',
    percentage: 'Maksutavalla {{method}} käsittelymaksu on {{percentage}} % tilauksen summasta.',
    percentage_floor:
      'Maksutavalla {{method}} käsittelymaksu on {{percentage}} % tilauksen summasta, vähintään kuitenkin {{floor}}.',
    fixed: 'Maksutavalla {{method}} käsittelymaksu on {{fixed}} maksua kohden.',
    fixed_floor: 'Maksutavalla {{method}} käsittelymaksu on {{fixed}} maksua kohden, vähintään kuitenkin {{floor}}.',
    combined:
      'Maksutavalla {{method}} käsittelymaksu on {{fixed}} kiinteänä summana sekä {{percentage}} % tilauksen summasta.',
    combined_floor:
      'Maksutavalla {{method}} käsittelymaksu on {{fixed}} kiinteänä summana sekä {{percentage}} % tilauksen summasta, vähintään kuitenkin {{floor}}.',
    redundant_floor:
      'Vähimmäissumma {{floor}} ei koskaan astu voimaan — kiinteä summa saavuttaa sen jo joka maksussa. Aseta se suuremmaksi kuin {{fixed}} tai poista se.',
  },
  example: 'Esimerkki: {{total}} tilauksesta käsittelymaksu on {{fee}}.',
};
